import { RESET_USER } from ".";
import { methods } from "../constants/constants";
import { getMateriaById } from "../utils/dataHandlers/MateriasDataHandler";
import { getPreguntaById, getPreguntasExamenesAcademiaById } from "../utils/dataHandlers/PreguntasDataHandler";

export const types = {
  GET_PREGUNTAS_BEGINS: 'PREGUNTAS/GET_PREGUNTAS_BEGINS',
  GET_PREGUNTAS_SUCCESS: 'PREGUNTAS/GET_PREGUNTAS_SUCCESS',
  GET_PREGUNTAS_FAILURE: 'PREGUNTAS/GET_PREGUNTAS_FAILURE',
  GET_PREGUNTAS_UPDATE: 'PREGUNTAS/GET_PREGUNTAS_UPDATE',

  POST_PREGUNTAS_BEGINS: 'PREGUNTAS/POST_PREGUNTAS_BEGINS',
  POST_PREGUNTAS_SUCCESS: 'PREGUNTAS/POST_PREGUNTAS_SUCCESS',
  POST_PREGUNTAS_FAILURE: 'PREGUNTAS/POST_PREGUNTAS_FAILURE',
  RESET_POST_PREGUNTAS: 'PREGUNTAS/RESET_POST_PREGUNTAS',

  EDIT_PREGUNTAS_BEGINS: 'PREGUNTAS/EDIT_PREGUNTAS_BEGINS',
  EDIT_PREGUNTAS_SUCCESS: 'PREGUNTAS/EDIT_PREGUNTAS_SUCCESS',
  EDIT_PREGUNTAS_FAILURE: 'PREGUNTAS/EDIT_PREGUNTAS_FAILURE',
  RESET_EDIT_PREGUNTAS: 'PREGUNTAS/RESET_EDIT_PREGUNTAS',

  DELETE_PREGUNTAS_BEGINS: 'PREGUNTAS/DELETE_PREGUNTAS_BEGINS',
  DELETE_PREGUNTAS_SUCCESS: 'PREGUNTAS/DELETE_PREGUNTAS_SUCCESS',
  DELETE_PREGUNTAS_FAILURE: 'PREGUNTAS/DELETE_PREGUNTAS_FAILURE',
  RESET_DELETE_PREGUNTAS: 'PREGUNTAS/RESET_DELETE_PREGUNTAS',

  GET_PREGUNTA_BEGINS: 'PREGUNTAS/GET_PREGUNTA_BEGINS',
  GET_PREGUNTA_SUCCESS: 'PREGUNTAS/GET_PREGUNTA_SUCCESS',
  GET_PREGUNTA_FAILURE: 'PREGUNTAS/GET_PREGUNTA_FAILURE',
  GET_PREGUNTA_UPDATE: 'PREGUNTAS/GET_PREGUNTA_UPDATE',

  GET_PREGUNTAS_EXAMENES_ACADEMIA_BEGINS: 'PREGUNTAS/GET_PREGUNTAS_EXAMENES_ACADEMIA_BEGINS',
  GET_PREGUNTAS_EXAMENES_ACADEMIA_SUCCESS: 'PREGUNTAS/GET_PREGUNTAS_EXAMENES_ACADEMIA_SUCCESS',
  GET_PREGUNTAS_EXAMENES_ACADEMIA_FAILURE: 'PREGUNTAS/GET_PREGUNTAS_EXAMENES_ACADEMIA_FAILURE',
  GET_PREGUNTAS_EXAMENES_ACADEMIA_UPDATE: 'PREGUNTAS/GET_PREGUNTAS_EXAMENES_ACADEMIA_UPDATE',
  RESET_GET_PREGUNTAS_EXAMENES_ACADEMIA: 'PREGUNTAS/RESET_GET_PREGUNTAS_EXAMENES_ACADEMIA',

  GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_BEGINS: 'PREGUNTAS/GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_BEGINS',
  GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_SUCCESS: 'PREGUNTAS/GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_SUCCESS',
  GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_FAILURE: 'PREGUNTAS/GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_FAILURE',
  GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_UPDATE: 'PREGUNTAS/GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_UPDATE',
  RESET_GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD: 'PREGUNTAS/RESET_GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD',

  POST_EXPORT_BUSCADOR_PREGUNTAS_PDF_BEGINS: 'PREGUNTAS/POST_EXPORT_BUSCADOR_PREGUNTAS_PDF_BEGINS',
  POST_EXPORT_BUSCADOR_PREGUNTAS_PDF_SUCCESS: 'PREGUNTAS/POST_EXPORT_BUSCADOR_PREGUNTAS_PDF_SUCCESS',
  POST_EXPORT_BUSCADOR_PREGUNTAS_PDF_FAILURE: 'PREGUNTAS/POST_EXPORT_BUSCADOR_PREGUNTAS_PDF_FAILURE',
  RESET_POST_EXPORT_BUSCADOR_PREGUNTAS_PDF: 'PREGUNTAS/RESET_POST_EXPORT_BUSCADOR_PREGUNTAS_PDF',

  POST_PREGUNTA_CON_OPCIONES_BEGINS: 'PREGUNTAS/POST_PREGUNTA_CON_OPCIONES_BEGINS',
  POST_PREGUNTA_CON_OPCIONES_SUCCESS: 'PREGUNTAS/POST_PREGUNTA_CON_OPCIONES_SUCCESS',
  POST_PREGUNTA_CON_OPCIONES_FAILURE: 'PREGUNTAS/POST_PREGUNTA_CON_OPCIONES_FAILURE',
  RESET_POST_PREGUNTA_CON_OPCIONES: 'PREGUNTAS/RESET_POST_PREGUNTA_CON_OPCIONES',

  EDIT_PREGUNTA_CON_OPCIONES_BEGINS: 'PREGUNTAS/EDIT_PREGUNTA_CON_OPCIONES_BEGINS',
  EDIT_PREGUNTA_CON_OPCIONES_SUCCESS: 'PREGUNTAS/EDIT_PREGUNTA_CON_OPCIONES_SUCCESS',
  EDIT_PREGUNTA_CON_OPCIONES_FAILURE: 'PREGUNTAS/EDIT_PREGUNTA_CON_OPCIONES_FAILURE',
  EDIT_POST_PREGUNTA_CON_OPCIONES: 'PREGUNTAS/EDIT_POST_PREGUNTA_CON_OPCIONES',

  UPDATE_PREGUNTAS_EXAMENES: 'PREGUNTAS/UPDATE_PREGUNTAS_EXAMENES',
  UPDATE_PREGUNTAS_EXAMENES_CRUD: 'UPDATE_PREGUNTAS_EXAMENES_CRUD',

  GET_RECUENTO_MATERIAS_BEGINS: 'PREGUNTAS/GET_RECUENTO_MATERIAS_BEGINS',
  GET_RECUENTO_MATERIAS_SUCCESS: 'PREGUNTAS/GET_RECUENTO_MATERIAS_SUCCESS',
  GET_RECUENTO_MATERIAS_FAILURE: 'PREGUNTAS/GET_RECUENTO_MATERIAS_FAILURE',
  SET_NUM_PREGUNTAS_SEL_RECUENTO_MATERIAS: 'PREGUNTAS/SET_NUM_PREGUNTAS_SEL_RECUENTO_MATERIAS',
  SET_NUM_PREGUNTAS_SEL_RECUENTO_CASOS_CLINICOS: 'PREGUNTAS/SET_NUM_PREGUNTAS_SEL_RECUENTO_CASOS_CLINICOS',

  GET_CASOS_CLINICOS_EXAMEN_BEGINS: 'PREGUNTAS/GET_CASOS_CLINICOS_EXAMEN_BEGINS',
  GET_CASOS_CLINICOS_EXAMEN_SUCCESS: 'PREGUNTAS/GET_CASOS_CLINICOS_EXAMEN_SUCCESS',
  GET_CASOS_CLINICOS_EXAMEN_FAILURE: 'PREGUNTAS/GET_CASOS_CLINICOS_EXAMEN_FAILURE',
  POST_CASO_CLINICO_BEGINS: 'PREGUNTAS/POST_CASO_CLINICO_BEGINS',
  PUT_CASO_CLINICO_BEGINS: 'PREGUNTAS/PUT_CASO_CLINICO_BEGINS',
  DELETE_CASO_CLINICO_BEGINS: 'PREGUNTAS/DELETE_CASO_CLINICO_BEGINS',
  SAVE_CASOS_CLINICOS_EXAMEN_BEGINS: 'PREGUNTAS/SAVE_CASOS_CLINICOS_EXAMEN_BEGINS',
  UPLOAD_CASOS_CLINICOS_EXCEL_BEGINS: 'PREGUNTAS/UPLOAD_CASOS_CLINICOS_EXCEL_BEGINS',
  CASOS_CLINICOS_MUTATION_SUCCESS: 'PREGUNTAS/CASOS_CLINICOS_MUTATION_SUCCESS',
  CASOS_CLINICOS_MUTATION_FAILURE: 'PREGUNTAS/CASOS_CLINICOS_MUTATION_FAILURE',
  RESET_CASOS_CLINICOS_EXAMEN: 'PREGUNTAS/RESET_CASOS_CLINICOS_EXAMEN',

  POST_PREGUNTAS_EXAMEN_BEGINS: 'PREGUNTAS/POST_PREGUNTAS_EXAMEN_BEGINS',
  POST_PREGUNTAS_EXAMEN_SUCCESS: 'PREGUNTAS/POST_PREGUNTAS_EXAMEN_SUCCESS',
  POST_PREGUNTAS_EXAMEN_FAILURE: 'PREGUNTAS/POST_PREGUNTAS_EXAMEN_FAILURE',
  RESET_POST_PREGUNTAS_EXAMEN: 'PREGUNTAS/RESET_POST_PREGUNTAS_EXAMEN',

  POST_PREGUNTAS_FINALIZAR_EXAMEN_BEGINS: 'PREGUNTAS/POST_PREGUNTAS_FINALIZAR_EXAMEN_BEGINS',
  POST_PREGUNTAS_FINALIZAR_EXAMEN_SUCCESS: 'PREGUNTAS/POST_PREGUNTAS_FINALIZAR_EXAMEN_SUCCESS',
  POST_PREGUNTAS_FINALIZAR_EXAMEN_FAILURE: 'PREGUNTAS/POST_PREGUNTAS_FINALIZAR_EXAMEN_FAILURE',
  RESET_POST_PREGUNTAS_FINALIZAR_EXAMEN: 'PREGUNTAS/RESET_POST_PREGUNTAS_FINALIZAR_EXAMEN',

  UPDATE_PREGUNTAS_EXAMEN_SUCCESS: 'PREGUNTAS/UPDATE_PREGUNTAS_EXAMEN_SUCCESS',

  SET_PREGUNTAS_EXAMEN_TIPO: 'PREGUNTAS/SET_PREGUNTAS_EXAMEN_TIPO',
  SET_IS_ERRONEAS: 'PREGUNTAS/SET_IS_ERRONEAS',

  GET_MATERIAS_ERRONEAS_BEGINS: 'PREGUNTAS/GET_MATERIAS_ERRONEAS_BEGINS',
  GET_MATERIAS_ERRONEAS_SUCCESS: 'PREGUNTAS/GET_MATERIAS_ERRONEAS_SUCCESS',
  GET_MATERIAS_ERRONEAS_FAILURE: 'PREGUNTAS/GET_MATERIAS_ERRONEAS_FAILURE',
  SET_NUM_PREGUNTAS_SEL_MATERIAS_ERRONEAS: 'PREGUNTAS/SET_NUM_PREGUNTAS_SEL_MATERIAS_ERRONEAS',

  DELETE_ALL_PREGUNTAS_ERRONEAS_BEGIN: 'PREGUNTAS/DELETE_ALL_PREGUNTAS_ERRONEAS_BEGIN',
  DELETE_ALL_PREGUNTAS_ERRONEAS_SUCCESS: 'PREGUNTAS/DELETE_ALL_PREGUNTAS_ERRONEAS_SUCCESS',
  DELETE_ALL_PREGUNTAS_ERRONEAS_FAILURE: 'PREGUNTAS/DELETE_ALL_PREGUNTAS_ERRONEAS_FAILURE',
  RESET_DELETE_ALL_PREGUNTAS_ERRONEAS: 'PREGUNTAS/RESET_DELETE_ALL_PREGUNTAS_ERRONEAS',

}

export const initialState = {

  preguntas: [],
  preguntasFetching: false,
  preguntasError: null,
  
  preguntasStatus: null,
  preguntasStatusData: null,
  preguntasStatusFetching: false,
  preguntasStatusError: null,

  preguntasEditStatus: null,
  preguntasEditStatusData: null,
  preguntasEditStatusFetching: false,
  preguntasEditStatusError: null,

  preguntasDeleteStatus: null,
  preguntasDeleteStatusData: null,
  preguntasDeleteStatusFetching: false,
  preguntasDeleteStatusError: null,

  preguntaFetching: false,
  preguntaError: null,

  preguntasExamenesAcademia: [],
  preguntasExamenesAcademiaFetching: false,
  preguntasExamenesAcademiaError: null,
  preguntasExamenesAcademiaReset: false,

  preguntasExamenesAcademiaCrud: [],
  preguntasExamenesAcademiaCrudFetching: false,
  preguntasExamenesAcademiaCrudError: null,
  preguntasExamenesAcademiaCrudReset: false,

  preguntasExportBuscadorPdfStatus: null,
  preguntasExportBuscadorPdfStatusData: null,
  preguntasExportBuscadorPdfFetching: false,
  preguntasExportBuscadorPdfError: null,

  preguntaConOpcionesStatus: null,
  preguntaConOpcionesStatusData: null,
  preguntaConOpcionesStatusFetching: false,
  preguntaConOpcionesStatusError: null,

  preguntaConOpcionesEditStatus: null,
  preguntaConOpcionesEditStatusData: null,
  preguntaConOpcionesEditStatusFetching: false,
  preguntaConOpcionesEditStatusError: null,

  recuentoMaterias: null,
  recuentoMateriasFetching: false,
  recuentoMateriasError: null,

  casosClinicosExamen: [],
  casosClinicosExamenId: null,
  casosClinicosExamenFetching: false,
  casosClinicosExamenError: null,
  casosClinicosMutationStatus: null,
  casosClinicosMutationFetching: false,
  casosClinicosMutationError: null,

  preguntasExamen: null,
  preguntasExamenTipo: '',
  isErroneas: false,
  preguntasExamenReset: false,
  preguntasExamenFetching: false,
  preguntasExamenError: null,

  preguntasFinalizarExamen: null,
  preguntasFinalizarExamenReset: false,
  preguntasFinalizarExamenFetching: false,
  preguntasFinalizarExamenError: null,

  materiasErroneas: null,
  materiasErroneasFetching: false,
  materiasErroneasError: null,

  deleteAllPreguntasErroneasStatus: null,
  deleteAllPreguntasErroneasStatusData: null,
  deleteAllPreguntasErroneasStatusFetching: false,
  deleteAllPreguntasErroneasStatusError: null,

}

const normalizeCasosClinicosMutationPayload = (payload) => {
  if (Array.isArray(payload)) {
    return {
      idExamen: payload[0]?.idExamen || null,
      casosClinicos: payload,
    };
  }

  return {
    idExamen: payload?.idExamen || null,
    casosClinicos: payload?.casosClinicos || [],
    examen: payload?.examen || null,
  };
};

const buildCasoClinicoPreguntaMap = (casosClinicos = []) => {
  const map = {};

  casosClinicos.forEach((casoClinico) => {
    (casoClinico.preguntas || []).forEach((pregunta) => {
      const idPregunta = pregunta.idPregunta || pregunta.id;
      if (idPregunta) {
        map[idPregunta] = {
          id: casoClinico.id,
          numero: casoClinico.numero,
          enunciado: casoClinico.enunciado,
        };
      }
    });
  });

  return map;
};

const updateCasosClinicosInExamenes = (examenes, idExamen, casosClinicos) => {
  if (!idExamen || !Array.isArray(examenes)) {
    return examenes;
  }

  const casosPreguntaMap = buildCasoClinicoPreguntaMap(casosClinicos);

  return examenes.map((examen) => {
    if (`${examen?.idExamen}` !== `${idExamen}` || !Array.isArray(examen.listaPreguntas)) {
      return examen;
    }

    return {
      ...examen,
      listaPreguntas: examen.listaPreguntas.map((pregunta) => {
        const idPregunta = pregunta.idPregunta || pregunta.id;
        return {
          ...pregunta,
          casoClinico: casosPreguntaMap[idPregunta] || null,
        };
      }),
    };
  });
};

const upsertExamen = (examenes, examen) => {
  if (!examen?.idExamen || !Array.isArray(examenes)) {
    return examenes;
  }

  const hasExam = examenes.some(currentExamen => `${currentExamen?.idExamen}` === `${examen.idExamen}`);

  if (hasExam) {
    return examenes.map(currentExamen => (
      `${currentExamen?.idExamen}` === `${examen.idExamen}`
        ? { ...currentExamen, ...examen }
        : currentExamen
    ));
  }

  return [
    ...examenes,
    examen,
  ];
};

const PreguntasReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_USER:
      return initialState;

    case types.GET_PREGUNTAS_BEGINS: {
      return {
        ...state,
        preguntasFetching: true,
        preguntasError: null,
      }
    }
    case types.GET_PREGUNTAS_SUCCESS: {
        //debugger;
      const data = action.payload;
      return {
        ...state,
        preguntas: data,
        preguntasFetching: false,
        preguntasError: null,
      }
    }
    case types.GET_PREGUNTAS_FAILURE:
      return { 
        ...state,
        preguntasFetching: false,
        preguntasError: action.payload,
    }
    case types.GET_PREGUNTAS_UPDATE: {
          //debugger;
      const { data, method } = action.payload;
      let updatePreguntas = state.preguntas;
      const exist = getPreguntaById(updatePreguntas, data.id);
      if (method === methods.DELETE) {
        updatePreguntas = updatePreguntas.filter((pregunta) => {
          return pregunta.id !== data.id;
        });
      } else {
          if (!exist) {
          updatePreguntas.push(data);
        } else {
            updatePreguntas = updatePreguntas.map((pregunta) => {
                //debugger;
            if(pregunta.id === data.id){
              pregunta.enunciado = data.enunciado;
              pregunta.numero = data.numero;
              pregunta.correcta = data.correcta;
              pregunta.id_materia = data.id_materia;
            }
            return pregunta;
          });
        }
      }
      return {
        ...state,
        preguntas: updatePreguntas,
        preguntasFetching: false,
        preguntasError: null,
      }
    }
    case types.POST_PREGUNTAS_BEGINS: {
      return {
        ...state,
        preguntasStatusFetching: true,
        preguntasStatusError: null,
      }
    }
    case types.POST_PREGUNTAS_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        preguntasStatus: data.status,
        preguntasStatusData: data.data,
        preguntasStatusFetching: false,
        preguntasStatusError: null,
      }
    }
    case types.POST_PREGUNTAS_FAILURE:
      return { 
        ...state,
        preguntasStatusFetching: false,
        preguntasStatusError: action.payload,
    }
    case types.RESET_POST_PREGUNTAS:
    return { 
      ...state,
      preguntasStatus: null,
      preguntasStatusData: null,
      preguntasStatusFetching: false,
      preguntasStatusError: null,
    }
    case types.EDIT_PREGUNTAS_BEGINS: {
      return {
        ...state,
        preguntasEditStatusFetching: true,
        preguntasEditStatusError: null,
      }
    }
    case types.EDIT_PREGUNTAS_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        preguntasEditStatus: data.status,
        preguntasEditStatusData: data.data,
        preguntasEditStatusFetching: false,
        preguntasEditStatusError: null,
      }
    }
    case types.EDIT_PREGUNTAS_FAILURE:
      return { 
        ...state,
        preguntasEditStatusFetching: false,
        preguntasEditStatusError: action.payload,
    }
    case types.RESET_EDIT_PREGUNTAS:
      return { 
        ...state,
        preguntasEditStatus: null,
        preguntasEditStatusData: null,
        preguntasEditStatusFetching: false,
        preguntasEditStatusError: null,
    }
    case types.DELETE_PREGUNTAS_BEGINS: {
      return {
        ...state,
        preguntasDeleteStatusFetching: true,
        preguntasDeleteStatusError: null,
      }
    }
    case types.DELETE_PREGUNTAS_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        preguntasDeleteStatus: data.status,
        preguntasDeleteStatusData: data.data,
        preguntasDeleteStatusFetching: false,
        preguntasDeleteStatusError: null,
      }
    }
    case types.DELETE_PREGUNTAS_FAILURE:
      return { 
        ...state,
        preguntasDeleteStatusFetching: false,
        preguntasDeleteStatusError: action.payload,
    }
    case types.RESET_DELETE_PREGUNTAS:
      return { 
        ...state,
        preguntasDeleteStatus: null,
        preguntasDeleteStatusData: null,
        preguntasDeleteStatusFetching: false,
        preguntasDeleteStatusError: null,
    }
    case types.GET_PREGUNTA_BEGINS: {
      return {
        ...state,
        preguntaFetching: true,
        preguntaError: null,
      }
    }
    case types.GET_PREGUNTA_SUCCESS: {
      const data = action.payload;
      const { preguntas: newPreguntas } = state;
      const exist = getPreguntaById(newPreguntas, data.id);
      if (!exist) {
        newPreguntas.push(newPreguntas);
      }
      return {
        ...state,
        preguntas: newPreguntas,
        preguntaFetching: false,
        preguntaError: null,
      }
    }
    case types.GET_PREGUNTA_FAILURE:
      return { 
        ...state,
        preguntaFetching: false,
        preguntaError: action.payload,
    }
    case types.GET_PREGUNTAS_EXAMENES_ACADEMIA_BEGINS: {
      return {
        ...state,
        preguntasExamenesAcademiaFetching: true,
        preguntasExamenesAcademiaError: null,
        preguntasExamenesAcademiaReset: false,
      }
    }
    case types.GET_PREGUNTAS_EXAMENES_ACADEMIA_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        preguntasExamenesAcademia: data,
        preguntasExamenesAcademiaFetching: false,
        preguntasExamenesAcademiaError: null,
        preguntasExamenesAcademiaReset: false,
      }
    }
    case types.GET_PREGUNTAS_EXAMENES_ACADEMIA_FAILURE:
      return { 
        ...state,
        preguntasExamenesAcademiaFetching: false,
        preguntasExamenesAcademiaError: action.payload,
        preguntasExamenesAcademiaReset: false,
    }
    case types.GET_PREGUNTAS_EXAMENES_ACADEMIA_UPDATE: {
      const data = action.payload;

      if (!data?.idExamen) {
        return state;
      }

      const currentPreguntasExamenesAcademia = Array.isArray(state.preguntasExamenesAcademia)
        ? state.preguntasExamenesAcademia
        : [];
      const hasExam = currentPreguntasExamenesAcademia.some((examen) => `${examen?.idExamen}` === `${data.idExamen}`);
      const newPreguntasExamenesAcademia = hasExam
        ? currentPreguntasExamenesAcademia.map((examen) => (
            `${examen?.idExamen}` === `${data.idExamen}`
              ? { ...examen, ...data }
              : examen
          ))
        : [
            ...currentPreguntasExamenesAcademia,
            data,
          ];

      return {
        ...state,
        preguntasExamenesAcademia: newPreguntasExamenesAcademia,
        preguntasExamenesAcademiaFetching: false,
        preguntasExamenesAcademiaError: null,
        preguntasExamenesAcademiaReset: false,
      }
    }
    case types.RESET_GET_PREGUNTAS_EXAMENES_ACADEMIA: {
      return {
        ...state,
        preguntasExamenesAcademia: [],
        preguntasExamenesAcademiaFetching: false,
        preguntasExamenesAcademiaError: null,
        preguntasExamenesAcademiaReset: true,
      }
    }
    case types.GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_BEGINS: {
      return {
        ...state,
        preguntasExamenesAcademiaCrudFetching: true,
        preguntasExamenesAcademiaCrudError: null,
        preguntasExamenesAcademiaCrudReset: false,
      }
    }
    case types.GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        preguntasExamenesAcademiaCrud: data,
        preguntasExamenesAcademiaCrudFetching: false,
        preguntasExamenesAcademiaCrudError: null,
        preguntasExamenesAcademiaCrudReset: false,
      }
    }
    case types.GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_FAILURE:
      return { 
        ...state,
        preguntasExamenesAcademiaCrudFetching: false,
        preguntasExamenesAcademiaCrudError: action.payload,
        preguntasExamenesAcademiaCrudReset: false,
    }
    case types.GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_UPDATE: {
      const data = action.payload;

      if (!data?.idExamen) {
        return state;
      }

      const currentPreguntasExamenesAcademiaCrud = Array.isArray(state.preguntasExamenesAcademiaCrud)
        ? state.preguntasExamenesAcademiaCrud
        : [];
      const hasExam = currentPreguntasExamenesAcademiaCrud.some((examen) => `${examen?.idExamen}` === `${data.idExamen}`);
      const newPreguntasExamenesAcademiaCrud = hasExam
        ? currentPreguntasExamenesAcademiaCrud.map((examen) => (
            `${examen?.idExamen}` === `${data.idExamen}`
              ? { ...examen, ...data }
              : examen
          ))
        : [
            ...currentPreguntasExamenesAcademiaCrud,
            data,
          ];

      return {
        ...state,
        preguntasExamenesAcademiaCrud: newPreguntasExamenesAcademiaCrud,
        preguntasExamenesAcademiaCrudFetching: false,
        preguntasExamenesAcademiaCrudError: null,
        preguntasExamenesAcademiaCrudReset: false,
      }
    }
    case types.RESET_GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD: {
      return {
        ...state,
        preguntasExamenesAcademiaCrud: [],
        preguntasExamenesAcademiaCrudFetching: false,
        preguntasExamenesAcademiaCrudError: null,
        preguntasExamenesAcademiaCrudReset: true,
      }
    }
    case types.POST_EXPORT_BUSCADOR_PREGUNTAS_PDF_BEGINS: {
      return {
        ...state,
        preguntasExportBuscadorPdfStatus: null,
        preguntasExportBuscadorPdfStatusData: null,
        preguntasExportBuscadorPdfFetching: true,
        preguntasExportBuscadorPdfError: null,
      }
    }
    case types.POST_EXPORT_BUSCADOR_PREGUNTAS_PDF_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        preguntasExportBuscadorPdfStatus: 'success',
        preguntasExportBuscadorPdfStatusData: data,
        preguntasExportBuscadorPdfFetching: false,
        preguntasExportBuscadorPdfError: null,
      }
    }
    case types.POST_EXPORT_BUSCADOR_PREGUNTAS_PDF_FAILURE:
      return {
        ...state,
        preguntasExportBuscadorPdfStatus: null,
        preguntasExportBuscadorPdfStatusData: null,
        preguntasExportBuscadorPdfFetching: false,
        preguntasExportBuscadorPdfError: action.payload,
      }
    case types.RESET_POST_EXPORT_BUSCADOR_PREGUNTAS_PDF:
      return {
        ...state,
        preguntasExportBuscadorPdfStatus: null,
        preguntasExportBuscadorPdfStatusData: null,
        preguntasExportBuscadorPdfFetching: false,
        preguntasExportBuscadorPdfError: null,
      }
    case types.POST_PREGUNTA_CON_OPCIONES_BEGINS: {
      return {
        ...state,
        preguntaConOpcionesStatusFetching: true,
        preguntaConOpcionesStatusError: null,
      }
    }
    case types.POST_PREGUNTA_CON_OPCIONES_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        preguntaConOpcionesStatus: data.status,
        preguntaConOpcionesStatusData: data.data,
        preguntaConOpcionesStatusFetching: false,
        preguntaConOpcionesStatusError: null,
      }
    }
    case types.POST_PREGUNTA_CON_OPCIONES_FAILURE:
      return { 
        ...state,
        preguntaConOpcionesStatusFetching: false,
        preguntaConOpcionesStatusError: action.payload,
    }
    case types.RESET_POST_PREGUNTA_CON_OPCIONES:
    return { 
      ...state,
      preguntaConOpcionesStatus: null,
      preguntaConOpcionesStatusData: null,
      preguntaConOpcionesStatusFetching: false,
      preguntaConOpcionesStatusError: null,
    }
    case types.EDIT_PREGUNTA_CON_OPCIONES_BEGINS: {
      return {
        ...state,
        preguntaConOpcionesEditStatusFetching: true,
        preguntaConOpcionesEditStatusError: null,
      }
    }
    case types.EDIT_PREGUNTA_CON_OPCIONES_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        preguntaConOpcionesEditStatus: data.status,
        preguntaConOpcionesEditStatusData: data.data,
        preguntaConOpcionesEditStatusFetching: false,
        preguntaConOpcionesEditStatusError: null,
      }
    }
    case types.EDIT_PREGUNTA_CON_OPCIONES_FAILURE:
      return { 
        ...state,
        preguntaConOpcionesEditStatusFetching: false,
        preguntaConOpcionesEditStatusError: action.payload,
    }
    case types.EDIT_POST_PREGUNTA_CON_OPCIONES:
    return { 
      ...state,
      preguntaConOpcionesEditStatus: null,
      preguntaConOpcionesEditStatusData: null,
      preguntaConOpcionesEditStatusFetching: false,
      preguntaConOpcionesEditStatusError: null,
    }
    case types.UPDATE_PREGUNTAS_EXAMENES: {
      const { data, method, dataToAdd, materiasDisponibles } = action.payload;
      let updatePreguntasExamenes = [
        ...state.preguntasExamenesAcademia
      ]
      const newPreguntasExamenesAcademia = []
      // primeros buscamos en el array qué examen estamos modificando
      // 
      // const examen = getPreguntasExamenesAcademiaById(updatePreguntasExamenes, data.id_examen);
      if (method === methods.DELETE) {
        updatePreguntasExamenes.forEach((examen) => {
          if (examen.idExamen === data.id_examen && Array.isArray(examen.listaPreguntas) && examen.listaPreguntas.length > 0) {
            examen.listaPreguntas = examen.listaPreguntas.filter((pregunta) => {
              return pregunta.id !== data.id;
            });
          }
          newPreguntasExamenesAcademia.push(examen);
        });
      } else if (method === methods.PUT) {
      updatePreguntasExamenes.forEach((examen) => {
        if (examen.idExamen === data.id_examen && Array.isArray(examen.listaPreguntas) && examen.listaPreguntas.length > 0) {
          examen.listaPreguntas = examen.listaPreguntas.map((pregunta) => {
            if (pregunta.id === data.id) {
              const materia = getMateriaById(materiasDisponibles, data.id_materia)
              const newPregunta = {
                ...pregunta,
                ...data,
                numeroPregunta: data.numero,
                idExamen: data.id_examen,
                idMateria: data.id_materia,
                nombreMateria: materia && materia.nombre
              }
              return newPregunta
            } else {
              return pregunta;
            }
          });
        }
        newPreguntasExamenesAcademia.push(examen);
      });
      } else if (method === methods.POST) {
        updatePreguntasExamenes.forEach((examen) => {
          if (examen.idExamen === data.id_examen && Array.isArray(examen.listaPreguntas) && examen.listaPreguntas.length > 0) {
            const newPregunta = {
              ...data,
              ...dataToAdd,
            }
            examen.listaPreguntas.push(newPregunta);
          }
          newPreguntasExamenesAcademia.push(examen);
        });
      }
      return {
        ...state,
        preguntasExamenesAcademia: newPreguntasExamenesAcademia,
        preguntasExamenesAcademiaFetching: false,
        preguntasExamenesAcademiaError: null,
      }
    }
    case types.UPDATE_PREGUNTAS_EXAMENES_CRUD: {
      const { data, method, dataToAdd, materiasDisponibles } = action.payload;
      let updatePreguntasExamenesCrud = [
        ...state.preguntasExamenesAcademiaCrud
      ]
      const newPreguntasExamenesAcademiaCrud = []
      // primeros buscamos en el array qué examen estamos modificando
      // 
      // const examen = getPreguntasExamenesAcademiaById(updatePreguntasExamenes, data.id_examen);
      if (method === methods.DELETE) {
        updatePreguntasExamenesCrud.forEach((examen) => {
          if (examen.idExamen === data.id_examen && Array.isArray(examen.listaPreguntas) && examen.listaPreguntas.length > 0) {
            examen.listaPreguntas = examen.listaPreguntas.filter((pregunta) => {
              return pregunta.id !== data.id;
            });
          }
          newPreguntasExamenesAcademiaCrud.push(examen);
        });
      } else if (method === methods.PUT) {
      updatePreguntasExamenesCrud.forEach((examen) => {
        if (examen.idExamen === data.id_examen && Array.isArray(examen.listaPreguntas) && examen.listaPreguntas.length > 0) {
          examen.listaPreguntas = examen.listaPreguntas.map((pregunta) => {
            if (pregunta.id === data.id) {
              const materia = getMateriaById(materiasDisponibles, data.id_materia)
              const newPregunta = {
                ...pregunta,
                ...data,
                numeroPregunta: data.numero,
                idExamen: data.id_examen,
                idMateria: data.id_materia,
                nombreMateria: materia && materia.nombre
              }
              return newPregunta
            } else {
              return pregunta;
            }
          });
        }
        newPreguntasExamenesAcademiaCrud.push(examen);
      });
      } else if (method === methods.POST) {
        updatePreguntasExamenesCrud.forEach((examen) => {
          if (examen.idExamen === data.id_examen && Array.isArray(examen.listaPreguntas) && examen.listaPreguntas.length > 0) {
            const newPregunta = {
              ...data,
              ...dataToAdd,
            }
            examen.listaPreguntas.push(newPregunta);
          }
          newPreguntasExamenesAcademiaCrud.push(examen);
        });
      }
      return {
        ...state,
        preguntasExamenesAcademiaCrud: newPreguntasExamenesAcademiaCrud,
        preguntasExamenesAcademiaCrudFetching: false,
        preguntasExamenesAcademiaCrudError: null,
      }
    }
    case types.GET_RECUENTO_MATERIAS_BEGINS: {
      return {
        ...state,
        recuentoMaterias: null,
        recuentoMateriasFetching: true,
        recuentoMateriasError: null,
      }
    }
    case types.GET_RECUENTO_MATERIAS_SUCCESS: {
      const data = action.payload;
      const { materias = [], casosClinicos = [], totalPreguntas } = data;
      const { recuentoMaterias } = state;

      const newMaterias = materias.map(materia => {
        // Encuentra la materia correspondiente en el estado actual
        const materiaState = recuentoMaterias && Array.isArray(recuentoMaterias.materias) && recuentoMaterias.materias.length > 0 && recuentoMaterias.materias.find(
          estadoMateria => estadoMateria.idMateria === materia.idMateria
        );
        return {
          ...materia,
          numPreguntasSel: materiaState ? (materiaState.numPreguntasSel > materia.recuento ? materia.recuento : materiaState.numPreguntasSel) : 0
        };
      });
      const newCasosClinicos = casosClinicos.map(casoClinico => {
        const casoState = recuentoMaterias && Array.isArray(recuentoMaterias.casosClinicos) && recuentoMaterias.casosClinicos.length > 0 && recuentoMaterias.casosClinicos.find(
          estadoCasoClinico => estadoCasoClinico.idCasoClinico === casoClinico.idCasoClinico
        );
        return {
          ...casoClinico,
          numPreguntasSel: casoState ? (casoState.numPreguntasSel > casoClinico.recuento ? casoClinico.recuento : casoState.numPreguntasSel) : 0
        };
      });
      const newRecuentoMaterias = {
        ...recuentoMaterias,
        totalPreguntas,
        materias: newMaterias,
        casosClinicos: newCasosClinicos,
      };
  
      return {
        ...state,
        recuentoMaterias: newRecuentoMaterias,
        recuentoMateriasFetching: false,
        recuentoMateriasError: null,
      };
    }
    case types.GET_RECUENTO_MATERIAS_FAILURE:
      return { 
        ...state,
        recuentoMateriasFetching: false,
        recuentoMateriasError: action.payload,
    }
    case types.SET_NUM_PREGUNTAS_SEL_RECUENTO_MATERIAS: {
      const data = action.payload;
      const indexMateria = state.recuentoMaterias.materias.findIndex(recuentoMateria => recuentoMateria.idMateria === data.idMateria);
      const newRecuentoMaterias = {
        ...state.recuentoMaterias,
      };
      if (indexMateria !== -1) {
        const newMaterias = [...state.recuentoMaterias.materias];
        newMaterias[indexMateria] = data;
        newRecuentoMaterias.materias = newMaterias
      }
      return {
        ...state,
        recuentoMaterias: newRecuentoMaterias,
        recuentoMateriasFetching: false,
        recuentoMateriasError: null,
      }
    }
    case types.SET_NUM_PREGUNTAS_SEL_RECUENTO_CASOS_CLINICOS: {
      const data = action.payload;
      const indexCasoClinico = state.recuentoMaterias.casosClinicos.findIndex(casoClinico => casoClinico.idCasoClinico === data.idCasoClinico);
      const newRecuentoMaterias = {
        ...state.recuentoMaterias,
      };
      if (indexCasoClinico !== -1) {
        const newCasosClinicos = [...state.recuentoMaterias.casosClinicos];
        newCasosClinicos[indexCasoClinico] = data;
        newRecuentoMaterias.casosClinicos = newCasosClinicos
      }
      return {
        ...state,
        recuentoMaterias: newRecuentoMaterias,
        recuentoMateriasFetching: false,
        recuentoMateriasError: null,
      }
    }
    case types.GET_CASOS_CLINICOS_EXAMEN_BEGINS: {
      return {
        ...state,
        casosClinicosExamenFetching: true,
        casosClinicosExamenError: null,
        casosClinicosMutationStatus: null,
      }
    }
    case types.GET_CASOS_CLINICOS_EXAMEN_SUCCESS: {
      return {
        ...state,
        casosClinicosExamen: action.payload || [],
        casosClinicosExamenId: action.idExamen || null,
        casosClinicosExamenFetching: false,
        casosClinicosExamenError: null,
      }
    }
    case types.GET_CASOS_CLINICOS_EXAMEN_FAILURE:
      return {
        ...state,
        casosClinicosExamenFetching: false,
        casosClinicosExamenError: action.payload,
      }
    case types.POST_CASO_CLINICO_BEGINS:
    case types.PUT_CASO_CLINICO_BEGINS:
    case types.DELETE_CASO_CLINICO_BEGINS:
    case types.SAVE_CASOS_CLINICOS_EXAMEN_BEGINS:
    case types.UPLOAD_CASOS_CLINICOS_EXCEL_BEGINS: {
      return {
        ...state,
        casosClinicosMutationStatus: null,
        casosClinicosMutationFetching: true,
        casosClinicosMutationError: null,
      }
    }
    case types.CASOS_CLINICOS_MUTATION_SUCCESS: {
      const { idExamen, casosClinicos, examen } = normalizeCasosClinicosMutationPayload(action.payload);
      const preguntasExamenesAcademia = updateCasosClinicosInExamenes(
        upsertExamen(state.preguntasExamenesAcademia, examen),
        idExamen,
        casosClinicos
      );
      const preguntasExamenesAcademiaCrud = updateCasosClinicosInExamenes(
        upsertExamen(state.preguntasExamenesAcademiaCrud, examen),
        idExamen,
        casosClinicos
      );

      return {
        ...state,
        casosClinicosExamen: casosClinicos,
        casosClinicosExamenId: idExamen,
        preguntasExamenesAcademia,
        preguntasExamenesAcademiaCrud,
        casosClinicosMutationStatus: 'success',
        casosClinicosMutationFetching: false,
        casosClinicosMutationError: null,
        casosClinicosExamenFetching: false,
        casosClinicosExamenError: null,
      }
    }
    case types.CASOS_CLINICOS_MUTATION_FAILURE:
      return {
        ...state,
        casosClinicosMutationStatus: null,
        casosClinicosMutationFetching: false,
        casosClinicosMutationError: action.payload,
      }
    case types.RESET_CASOS_CLINICOS_EXAMEN:
      return {
        ...state,
        casosClinicosExamen: [],
        casosClinicosExamenId: null,
        casosClinicosExamenFetching: false,
        casosClinicosExamenError: null,
        casosClinicosMutationStatus: null,
        casosClinicosMutationFetching: false,
        casosClinicosMutationError: null,
      }
    case types.POST_PREGUNTAS_EXAMEN_BEGINS: {
      return {
        ...state,
        preguntasExamenReset: false,
        preguntasExamenFetching: true,
        preguntasExamenError: null,
      }
    }
    case types.POST_PREGUNTAS_EXAMEN_SUCCESS: {
      const data = action.payload;
      const { examen, tipo, isErroneas } = data;
      const preguntasExamenTipoState = state.preguntasExamenTipo
      return {
        ...state,
        preguntasExamen: examen,
        preguntasExamenTipo: tipo || preguntasExamenTipoState,
        isErroneas,
        preguntasExamenReset: false,
        preguntasExamenFetching: false,
        preguntasExamenError: null,
      }
    }
    case types.POST_PREGUNTAS_EXAMEN_FAILURE:
      return { 
        ...state,
        preguntasExamenReset: false,
        preguntasExamenFetching: false,
        preguntasExamenError: action.payload,
    }
    case types.RESET_POST_PREGUNTAS_EXAMEN: {
      return {
        ...state,
        preguntasExamen: null,
        preguntasExamenTipo: '',
        isErroneas: false,
        preguntasExamenReset: true,
        preguntasExamenFetching: false,
        preguntasExamenError: null,
      }
    }
    case types.POST_PREGUNTAS_FINALIZAR_EXAMEN_BEGINS: {
      return {
        ...state,
        preguntasFinalizarExamenReset: false,
        preguntasFinalizarExamenFetching: true,
        preguntasFinalizarExamenError: null,
      }
    }
    case types.POST_PREGUNTAS_FINALIZAR_EXAMEN_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        preguntasFinalizarExamen: data,
        preguntasFinalizarExamenReset: false,
        preguntasFinalizarExamenFetching: false,
        preguntasFinalizarExamenError: null,
      }
    }
    case types.POST_PREGUNTAS_FINALIZAR_EXAMEN_FAILURE:
      return { 
        ...state,
        preguntasFinalizarExamenReset: false,
        preguntasFinalizarExamenFetching: false,
        preguntasFinalizarExamenError: action.payload,
    }
    case types.RESET_POST_PREGUNTAS_FINALIZAR_EXAMEN: {
      return {
        ...state,
        preguntasFinalizarExamen: null,
        preguntasFinalizarExamenReset: true,
        preguntasFinalizarExamenFetching: false,
        preguntasFinalizarExamenError: null,
      }
    }
    case types.UPDATE_PREGUNTAS_EXAMEN_SUCCESS: {
      const data = action.payload;
      const newPreguntasExamenes = state.preguntasExamenesAcademiaCrud
      const newPreguntasExamenesAcademia = state.preguntasExamenesAcademia

      if (newPreguntasExamenes && Array.isArray(newPreguntasExamenes) && newPreguntasExamenes.length > 0 && data && data.data && data.data.idExamen){
        newPreguntasExamenes.map(examen => {
          if (examen.idExamen === data.data.idExamen) {
            examen.visible = data.data.visible;
            examen.nombreExamen = data.data.nombreExamen;
          }
        })
      }
      if (newPreguntasExamenesAcademia && Array.isArray(newPreguntasExamenesAcademia) && newPreguntasExamenesAcademia.length > 0 && data && data.data && data.data.idExamen){
        newPreguntasExamenesAcademia.map(examen => {
          if (examen.idExamen === data.data.idExamen) {
            examen.visible = data.data.visible;
            examen.nombreExamen = data.data.nombreExamen;
          }
        })
      }

      return {
        ...state,
        preguntasExamenesAcademiaCrud: newPreguntasExamenes,
        preguntasExamenesAcademia: newPreguntasExamenesAcademia,
      }
    }
    case types.SET_PREGUNTAS_EXAMEN_TIPO: {
      const { tipo } = action;
      return {
        ...state,
        preguntasExamenTipo: tipo,
      }
    }
    case types.SET_IS_ERRONEAS: {
      const { isErroneas } = action;
      return {
        ...state,
        isErroneas,
      }
    }

    case types.GET_MATERIAS_ERRONEAS_BEGINS: {
      return {
        ...state,
        materiasErroneas: null,
        materiasErroneasFetching: true,
        materiasErroneasError: null,
      }
    }
    case types.GET_MATERIAS_ERRONEAS_SUCCESS: {
      const materias = action.payload;
      const { materiasErroneas } = state;

      const newMaterias = materias.map(materia => {
        // Encuentra la materia correspondiente en el estado actual
        const materiaState = materiasErroneas && Array.isArray(materiasErroneas) && materiasErroneas.length > 0 && materiasErroneas.find(
          estadoMateria => estadoMateria.idMateria === materia.idMateria
        );
        return {
          ...materia,
          numPreguntasSel: materiaState ? (materiaState.numPreguntasSel > materia.recuento ? materia.recuento : materiaState.numPreguntasSel) : 0
        };
      });
      const newRecuentoMaterias = {
        ...materiasErroneas,
        materias: newMaterias,
      };
  
      return {
        ...state,
        materiasErroneas: newRecuentoMaterias,
        materiasErroneasFetching: false,
        materiasErroneasError: null,
      };
    }
    case types.GET_MATERIAS_ERRONEAS_FAILURE:
      return { 
        ...state,
        materiasErroneasFetching: false,
        materiasErroneasError: action.payload,
    }
    case types.SET_NUM_PREGUNTAS_SEL_MATERIAS_ERRONEAS: {
      const data = action.payload;
      const indexMateria = state.materiasErroneas.materias.findIndex(recuentoMateria => recuentoMateria.idMateria === data.idMateria);
      const newRecuentoMaterias = {
        ...state.materiasErroneas,
      };
      if (indexMateria !== -1) {
        const newMaterias = [...state.materiasErroneas.materias];
        newMaterias[indexMateria] = data;
        newRecuentoMaterias.materias = newMaterias
      }
      return {
        ...state,
        materiasErroneas: newRecuentoMaterias,
        materiasErroneasFetching: false,
        materiasErroneasError: null,
      }
    }

    case types.DELETE_ALL_PREGUNTAS_ERRONEAS_BEGIN: {
      return {
        ...state,
        deleteAllPreguntasErroneasStatusFetching: true,
        deleteAllPreguntasErroneasStatusError: null,
      }
    }
    case types.DELETE_ALL_PREGUNTAS_ERRONEAS_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        materiasErroneas: null,
        deleteAllPreguntasErroneasStatus: data.status,
        deleteAllPreguntasErroneasStatusData: data.data,
        deleteAllPreguntasErroneasStatusFetching: false,
        deleteAllPreguntasErroneasStatusError: null,
      }
    }
    case types.DELETE_ALL_PREGUNTAS_ERRONEAS_FAILURE:
      return { 
        ...state,
        deleteAllPreguntasErroneasStatusFetching: false,
        deleteAllPreguntasErroneasStatusError: action.payload,
    }
    case types.RESET_DELETE_ALL_PREGUNTAS_ERRONEAS: {
      return {
        ...state,
        deleteAllPreguntasErroneasStatus: null,
        deleteAllPreguntasErroneasStatusData: null,
        deleteAllPreguntasErroneasStatusFetching: false,
        deleteAllPreguntasErroneasStatusError: null,
      }
    }
    
  default:
    return state
  }
}

export const actions = {
  getPreguntas: () => ({ type: types.GET_PREGUNTAS_BEGINS }),
  successGetPreguntas: data => ({ type: types.GET_PREGUNTAS_SUCCESS, payload: data, }),
  errorGetPreguntas: error => ({ type: types.GET_PREGUNTAS_FAILURE, payload: error, }),
  updatePreguntas: (data, method) => ({ type: types.GET_PREGUNTAS_UPDATE, payload: { data, method }, }),

  postPreguntas: pregunta => ({ type: types.POST_PREGUNTAS_BEGINS, pregunta }),
  successPostPreguntas: data => ({ type: types.POST_PREGUNTAS_SUCCESS, payload: data, }),
  errorPostPreguntas: error => ({ type: types.POST_PREGUNTAS_FAILURE, payload: error, }),
  resetPostPreguntas: () => ({ type: types.RESET_POST_PREGUNTAS }),

  editPreguntas: pregunta => ({ type: types.EDIT_PREGUNTAS_BEGINS, pregunta }),
  successEditPreguntas: data => ({ type: types.EDIT_PREGUNTAS_SUCCESS, payload: data, }),
  errorEditPreguntas: error => ({ type: types.EDIT_PREGUNTAS_FAILURE, payload: error, }),
  resetEditPreguntas: () => ({ type: types.RESET_EDIT_PREGUNTAS }),

  deletePreguntas: pregunta => ({ type: types.DELETE_PREGUNTAS_BEGINS, pregunta }),
  successDeletePreguntas: data => ({ type: types.DELETE_PREGUNTAS_SUCCESS, payload: data, }),
  errorDeletePreguntas: error => ({ type: types.DELETE_PREGUNTAS_FAILURE, payload: error, }),
  resetDeletePreguntas: () => ({ type: types.RESET_DELETE_PREGUNTAS }),

  getPregunta: () => ({ type: types.GET_PREGUNTA_BEGINS }),
  successGetPregunta: data => ({ type: types.GET_PREGUNTA_SUCCESS, payload: data, }),
  errorGetPregunta: error => ({ type: types.GET_PREGUNTA_FAILURE, payload: error, }),

  getPreguntasExamenesAcademia: () => ({ type: types.GET_PREGUNTAS_EXAMENES_ACADEMIA_BEGINS }),
  successGetPreguntasExamenesAcademia: data => ({ type: types.GET_PREGUNTAS_EXAMENES_ACADEMIA_SUCCESS, payload: data, }),
  errorGetPreguntasExamenesAcademia: error => ({ type: types.GET_PREGUNTAS_EXAMENES_ACADEMIA_FAILURE, payload: error, }),
  updateGetPreguntasExamenesAcademia: data => ({ type: types.GET_PREGUNTAS_EXAMENES_ACADEMIA_UPDATE, payload: data}),
  resetGetPreguntasExamenesAcademia: () => ({ type: types.RESET_GET_PREGUNTAS_EXAMENES_ACADEMIA }),

  getPreguntasExamenesAcademiaCrud: () => ({ type: types.GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_BEGINS }),
  successGetPreguntasExamenesAcademiaCrud: data => ({ type: types.GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_SUCCESS, payload: data, }),
  errorGetPreguntasExamenesAcademiaCrud: error => ({ type: types.GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_FAILURE, payload: error, }),
  updateGetPreguntasExamenesAcademiaCrud: data => ({ type: types.GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD_UPDATE, payload: data}),
  resetGetPreguntasExamenesAcademiaCrud: () => ({ type: types.RESET_GET_PREGUNTAS_EXAMENES_ACADEMIA_CRUD }),

  postExportBuscadorPreguntasPdf: exportRequest => ({ type: types.POST_EXPORT_BUSCADOR_PREGUNTAS_PDF_BEGINS, exportRequest }),
  successPostExportBuscadorPreguntasPdf: data => ({ type: types.POST_EXPORT_BUSCADOR_PREGUNTAS_PDF_SUCCESS, payload: data }),
  errorPostExportBuscadorPreguntasPdf: error => ({ type: types.POST_EXPORT_BUSCADOR_PREGUNTAS_PDF_FAILURE, payload: error }),
  resetPostExportBuscadorPreguntasPdf: () => ({ type: types.RESET_POST_EXPORT_BUSCADOR_PREGUNTAS_PDF }),

  postPreguntaConOpciones: pregunta => ({ type: types.POST_PREGUNTA_CON_OPCIONES_BEGINS, pregunta }),
  successPostPreguntaConOpciones: data => ({ type: types.POST_PREGUNTA_CON_OPCIONES_SUCCESS, payload: data, }),
  errorPostPreguntaConOpciones: error => ({ type: types.POST_PREGUNTA_CON_OPCIONES_FAILURE, payload: error, }),
  resetPostPreguntaConOpciones: () => ({ type: types.RESET_POST_PREGUNTA_CON_OPCIONES }),

  editPreguntaConOpciones: pregunta => ({ type: types.EDIT_PREGUNTA_CON_OPCIONES_BEGINS, pregunta }),
  successEditPreguntaConOpciones: data => ({ type: types.EDIT_PREGUNTA_CON_OPCIONES_SUCCESS, payload: data, }),
  errorEditPreguntaConOpciones: error => ({ type: types.EDIT_PREGUNTA_CON_OPCIONES_FAILURE, payload: error, }),
  resetEditPreguntaConOpciones: () => ({ type: types.EDIT_POST_PREGUNTA_CON_OPCIONES }),

  updatePreguntasExamenes: (data, method, dataToAdd, materiasDisponibles) => ({ type: types.UPDATE_PREGUNTAS_EXAMENES, payload: { data, method, dataToAdd, materiasDisponibles }, }),
  updatePreguntasExamenesCrud: (data, method, dataToAdd, materiasDisponibles) => ({ type: types.UPDATE_PREGUNTAS_EXAMENES_CRUD, payload: { data, method, dataToAdd, materiasDisponibles }, }),

  getRecuentoMaterias: idsExamen => ({ type: types.GET_RECUENTO_MATERIAS_BEGINS, idsExamen}),
  successGetRecuentoMaterias: data => ({ type: types.GET_RECUENTO_MATERIAS_SUCCESS, payload: data}),
  errorGetRecuentoMaterias: error => ({ type: types.GET_RECUENTO_MATERIAS_FAILURE, payload: error}),
  setNumPreguntasSelRecuentoMaterias: data => ({ type: types.SET_NUM_PREGUNTAS_SEL_RECUENTO_MATERIAS, payload: data}),
  setNumPreguntasSelRecuentoCasosClinicos: data => ({ type: types.SET_NUM_PREGUNTAS_SEL_RECUENTO_CASOS_CLINICOS, payload: data}),

  getCasosClinicosExamen: idExamen => ({ type: types.GET_CASOS_CLINICOS_EXAMEN_BEGINS, idExamen}),
  successGetCasosClinicosExamen: (data, idExamen) => ({ type: types.GET_CASOS_CLINICOS_EXAMEN_SUCCESS, payload: data, idExamen}),
  errorGetCasosClinicosExamen: error => ({ type: types.GET_CASOS_CLINICOS_EXAMEN_FAILURE, payload: error}),
  postCasoClinico: casoClinico => ({ type: types.POST_CASO_CLINICO_BEGINS, casoClinico}),
  putCasoClinico: (idCasoClinico, casoClinico) => ({ type: types.PUT_CASO_CLINICO_BEGINS, idCasoClinico, casoClinico}),
  deleteCasoClinico: (idCasoClinico, idExamen) => ({ type: types.DELETE_CASO_CLINICO_BEGINS, idCasoClinico, idExamen}),
  saveCasosClinicosExamen: (idExamen, casosClinicosRequest) => ({ type: types.SAVE_CASOS_CLINICOS_EXAMEN_BEGINS, idExamen, casosClinicosRequest}),
  uploadCasosClinicosExcel: (formData, idExamen) => ({ type: types.UPLOAD_CASOS_CLINICOS_EXCEL_BEGINS, formData, idExamen}),
  successCasosClinicosMutation: data => ({ type: types.CASOS_CLINICOS_MUTATION_SUCCESS, payload: data}),
  errorCasosClinicosMutation: error => ({ type: types.CASOS_CLINICOS_MUTATION_FAILURE, payload: error}),
  resetCasosClinicosExamen: () => ({ type: types.RESET_CASOS_CLINICOS_EXAMEN}),

  postPreguntasExamen: (preguntasExamen, tipo, isErroneas) => ({ type: types.POST_PREGUNTAS_EXAMEN_BEGINS, preguntasExamen, tipo, isErroneas}),
  successPostPreguntasExamen: data => ({ type: types.POST_PREGUNTAS_EXAMEN_SUCCESS, payload: data}),
  errorPostPreguntasExamen: error => ({ type: types.POST_PREGUNTAS_EXAMEN_FAILURE, payload: error}),
  resetPostPreguntasExamen: () => ({ type: types.RESET_POST_PREGUNTAS_EXAMEN }),

  postPreguntasFinalizarExamen: (preguntasExamen, isErroneas, modoExamen) => ({ type: types.POST_PREGUNTAS_FINALIZAR_EXAMEN_BEGINS, preguntasExamen, isErroneas, modoExamen}),
  successPostPreguntasFinalizarExamen: data => ({ type: types.POST_PREGUNTAS_FINALIZAR_EXAMEN_SUCCESS, payload: data}),
  errorPostPreguntasFinalizarExamen: error => ({ type: types.POST_PREGUNTAS_FINALIZAR_EXAMEN_FAILURE, payload: error}),
  resetPostPreguntasFinalizarExamen: () => ({ type: types.RESET_POST_PREGUNTAS_FINALIZAR_EXAMEN }),

  successUpdatePreguntasExamen: data => ({ type: types.UPDATE_PREGUNTAS_EXAMEN_SUCCESS, payload: data, }),

  setPreguntasExamenTipo: tipo => ({ type: types.SET_PREGUNTAS_EXAMEN_TIPO, tipo}),
  setIsErroneas: isErroneas => ({ type: types.SET_IS_ERRONEAS, isErroneas}),

  getMateriasErroneas: () => ({ type: types.GET_MATERIAS_ERRONEAS_BEGINS}),
  successGetMateriasErroneas: data => ({ type: types.GET_MATERIAS_ERRONEAS_SUCCESS, payload: data}),
  errorGetMateriasErroneas: error => ({ type: types.GET_MATERIAS_ERRONEAS_FAILURE, payload: error}),
  setNumPreguntasSelMateriasErroneas: data => ({ type: types.SET_NUM_PREGUNTAS_SEL_MATERIAS_ERRONEAS, payload: data}),
  
  deleteAllPreguntasErroneas: () => ({ type: types.DELETE_ALL_PREGUNTAS_ERRONEAS_BEGIN }),
  successDeleteAllPreguntasErroneas: data => ({ type: types.DELETE_ALL_PREGUNTAS_ERRONEAS_SUCCESS, payload: data, }),
  errorDeleteAllPreguntasErroneas: error => ({ type: types.DELETE_ALL_PREGUNTAS_ERRONEAS_FAILURE, payload: error, }),
  resetDeleteAllPreguntasErroneas: () => ({ type: types.RESET_DELETE_ALL_PREGUNTAS_ERRONEAS }),
}

export default PreguntasReducer;
